import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { theme } from "../../Assets/Theme/theme";

const TextInput = ({
  label,
  placeholder,
  value,
  onChange,
  type,
  startIcon,
  endIcon,
  name,
  bgColor,
  height,
  experience,
  fontSize,
  onClick,
  disabled,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box sx={{ mb: 2 }}>
      {label && (
        <Typography
          variant="body1"
          sx={{
            fontWeight: "700",
            mb: 1,
            color: "#121212",
            fontSize: fontSize ? fontSize : "20px",
          }}
        >
          {label}
        </Typography>
      )}

      <TextField
        placeholder={placeholder}
        variant="outlined"
        value={value}
        onChange={onChange}
        fullWidth
        name={name}
        onClick={onClick}
        type={
          type === "password" ? (!showPassword ? "password" : "text") : type
        }
        {...props}
        InputProps={{
          readOnly: disabled,
          startAdornment: startIcon && (
            <InputAdornment position="start">{startIcon}</InputAdornment>
          ),
          endAdornment:
            type === "password" ? (
              <InputAdornment position="end">
                <IconButton onClick={handleTogglePassword} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ) : (
              endIcon && (
                <InputAdornment position="end">
                  <IconButton edge="end">{endIcon}</IconButton>
                </InputAdornment>
              )
            ),
        }}
        sx={{
          background: bgColor && bgColor,
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            borderColor: "#ccc",
            height: height && height,

            "&:hover fieldset": {
              borderColor: "#ccc",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#ccc",
              borderWidth: "2px",
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ccc",
          },
        }}
      />
    </Box>
  );
};

export default TextInput;
